module.exports = __webpack_public_path__ + "img/21_79.58ecd59b.png";